import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import { pages } from 'pages';
import { useUser } from 'hooks/useUser';
import { ErrorButtonStyled, FallbackBody, FallbackWrapper } from './ErrorBoundary.styles';
import { LoadingSpinner } from '../LoadingSpinner';

const ErrorLaptopImg = React.lazy(() => import('shared/components/icons/ErrorLaptopImg'));

export function ErrorFallback({ is404 }: { is404?: boolean }) {
  const { t } = useTranslation();
  const { userResult } = useUser();

  const backToLink = userResult?.user
    ? `/${pages.DASHBOARD}`
    : `${window.location.host}/${pages.LOGIN}`;

  const handleGoBack = () => {
    window.history.replaceState(null, '', backToLink);
    window.history.go(0);
  };
  let errorCopy = t('error.generic.description');
  if (is404) {
    errorCopy = t('error.notFound.description');
  }

  const handleButtonAction = () => (is404 === true ? handleGoBack() : window.history.go(0));

  return (
    <FallbackWrapper>
      <FallbackBody>
        <h1>{is404 === true ? t('error.notFound.header') : t('error.generic.header')}</h1>
        <p>{errorCopy}</p>
        <ErrorButtonStyled
          $maxWidth={is404 === true ? '122px' : '148px'}
          onClick={handleButtonAction}
          onKeyUp={(e) => {
            if (e.key === 'Enter' || e.key === ' ') handleButtonAction();
          }}
        >
          <span>{is404 === true ? t('error.notFound.button') : t('error.generic.button')}</span>
        </ErrorButtonStyled>
      </FallbackBody>
      <Suspense fallback={<LoadingSpinner />}>
        <ErrorLaptopImg />
      </Suspense>
    </FallbackWrapper>
  );
}

export default ErrorFallback;
